import React, { useState, useEffect, useRef, useReducer } from 'react'
import {
  Panel,
  Row,
  Col,
  ControlLabel,
  Input,
  RadioGroup,
  Radio,
  SelectPicker,
  Uploader,
  Icon,
  InputGroup,
  List,
  Button,
  Table,
  Modal,
  Checkbox,
} from 'rsuite'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import {
  isImageOrPdf,
  isValidators,
  requiredFiled,
  getMaxLengthData,
} from '../../utils/ValidatorUtils'
import { cloneDeep, isEmpty } from 'lodash-es'
import {
  DATE_FORMAT,
  DATE_PICKER_FORMAT,
  DD_MM_YYYY_SLASH,
  LOCAL_DAY_TH,
} from '../../constants/date'
import EditSelectCell from '../../components/cell/EditSelectCell'
import EditTextCell from '../../components/cell/EditTextCell'
import EditNumberCell from '../../components/cell/EditNumberCell'
import InputNumberForm from '../../components/forms/input/InputNumberForm'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { budgetFormat } from '../../utils/formatterUtil'
import { sessionGetItemJSON, sessionGetItemStr } from '../../utils/sessionHelpers'
import notification from '../../utils/notification'
import { startLoading, doneLoading } from '../../utils/loading'
import { getReceivedFrom } from '../../redux/actions/incomeAndExpense'
import moment from 'moment'
import IncomeRecordFileTable from '../incomeRecordWidget/IncomeRecordFileTable'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import ShowLimitLength from '../../components/utils/ShowLimitLength'
import { downloadExpenseRequestAttachments } from '../../redux/actions/accountingExpenseRequest'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'
import { getValueFromOptions, maskIdCard } from '../../utils/dataUtil'
import ConfirmWidget from '../confirm/ConfirmWidget'

export default function AdvanceRefundForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  setIsEnableEdit = () => {},
  borrowAmont = 0,
  setBorrowAmont = () => {},
  payActive = '',
  setPayActive = () => {},
  accountingBorrowAvancesList = [],
  disabledForm = false,
  setDisabledForm = () => {},
  projectStartDate,
  projectEndDate,
  ...props
}) {
  // const { projectInfo } = props

  const triggerRef = React.useRef()
  const { Column, HeaderCell, Cell } = Table
  const [formSchema, setFormSchema] = useState(_schema)
  const [accChannel, setAccChannel] = useState(_schema.accountChannel.value || '2')
  const [confirmAccChannel, setConfirmAccChannel] = useState(
    _schema?.accountChannelConfirm?.value || '2'
  )
  const [receiveMoneyEtcVal, setReceiveMoneyEtcVal] = useState(_schema.receiveMoneyEtc.value)
  const [receiveMoneyEtcId, setReceiveMoneyEtcId] = useState(_schema.receiveMoneyEtc.id)
  const [fileTypeError, setFileTypeError] = useState(false)
  const [showReceiveMoneyEtc, setShowReceiveMoneyEtc] = useState(false)
  const [receivedFromSchema, setReceivedFromSchema] = useState()
  const [searchNameOrId, setSearchNameOrId] = useState()
  const [fileTableData, setFileTableData] = useState([])
  const [isCancel, setIsCancel] = useState(false)
  const [cancelTypeCode, setCancelTypeCode] = useState(_schema?.cancelType?.value || 1)
  const [isShowAlertMessage, setIsShowAlertMessage] = useState(false)

  const [borrowDate, setBorrowDate] = useState()

  const [_, forceUpdate] = useReducer((x) => x + 1, 0)
  const projectCode = sessionStorage.getItem('projectCode')
  const periodInfo = sessionGetItemJSON('periodInfo')
  const borrowId = sessionStorage.getItem('borrowId')
  const defaultMaxFileSize = 5

  useEffect(() => {
    setValue(formSchema?.accountChannel?.name, formSchema?.accountChannel?.value || '2')
    //setValue(formSchema?.attachFiles?.name, formSchema?.attachFiles?.values)
    setValue(formSchema?.bankAccount?.name, formSchema?.bankAccount?.value)
    setValue(formSchema?.amountBorrowed?.name, formSchema?.amountBorrowed?.value || 0)
    setBorrowAmont(formSchema?.amountBorrowed?.value || 0)
    setValue(formSchema?.receiveMoneyEtc?.name, formSchema?.receiveMoneyEtc?.value)
    register('listBorrowAdvance', formSchema?.listBorrowAdvance?.value)
    setValue(formSchema?.listBorrowAdvance?.name, formSchema?.listBorrowAdvance?.value)
    setValue(formSchema?.voucherNumber?.name, formSchema?.voucherNumber?.value || 'B-YY-XXXXX')
    setValue(formSchema?.payActive?.name, formSchema?.payActive?.value)
    setPayActive(formSchema?.payActive?.value || '')
    setValue(
      formSchema?.actureReturnDate?.name,
      formSchema.actureReturnDate.value
        ? moment(formSchema.actureReturnDate.value, DD_MM_YYYY_SLASH).toDate()
        : getDefaultActureReturnDate()
    )
    if (formSchema?.cancelTranferDate) {
      setValue(
        formSchema.cancelTranferDate.name,
        formSchema.cancelTranferDate.value
          ? moment(formSchema.cancelTranferDate.value, DD_MM_YYYY_SLASH).toDate()
          : moment().startOf('day').toDate()
      )
    }
    if (formSchema?.cancelDate) {
      setValue(
        formSchema.cancelDate.name,
        formSchema.cancelDate.value
          ? moment(formSchema.cancelDate.value, DD_MM_YYYY_SLASH).toDate()
          : moment().startOf('day').toDate()
      )
    }

    register('deleteFileIds', [])
    if (formSchema?.attachFiles?.values && formSchema?.attachFiles?.values?.length > 0) {
      setFileTableData(formSchema?.attachFiles?.values)
    }
  }, [formSchema])

  const handleCallReceivedFrom = async (nameOrId) => {
    try {
      let response = await getReceivedFrom(projectCode, nameOrId)
      if (response) {
        setReceivedFromSchema(response)
        setShowReceiveMoneyEtc(true)
        setTimeout(() => {
          forceUpdate()
        }, 500)
      } else {
        notification.open('error', {
          title: 'ไม่สำเร็จ no response',
        })
      }
    } catch (e) {
      if (e?.response?.data) {
        notification.open('error', {
          title: e.response.data.errorMessage || 'ไม่สำเร็จ',
        })
      } else {
        notification.open('error', {
          title: 'ไม่สำเร็จ no errorMessage',
        })
      }
    }
  }

  const handleSelectVender = (dataRow) => {
    setReceiveMoneyEtcVal(dataRow?.name)
    setValue(formSchema?.receiveMoneyEtc?.name, dataRow?.id)
    clearErrors(formSchema?.receiveMoneyEtc?.name)
    setShowReceiveMoneyEtc(false)
  }

  const handleDeleteFileTable = (rowData) => {
    let arr = getValues('deleteFileIds') || []
    arr.push(rowData.id)
    setValue('deleteFileIds', arr)

    let _fileTable = fileTableData?.filter((item) => item.id != rowData.id)
    setFileTableData(_fileTable)
  }

  const onDownload = async (fileObj) => {
    startLoading()
    try {
      var file = await downloadExpenseRequestAttachments(fileObj.id)
      var fileName = fileObj.label

      downloadFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    try {
      var file = await downloadExpenseRequestAttachments(fileObj.id)
      var fileName = fileObj.name

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'แสดง ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const renderBorrowAdvance = (id) => {
    let fullTitle = ''

    let obj = accountingBorrowAvancesList.find((i) => i.id == id)
    let date = new Date(obj.borrowerDate).toLocaleDateString('th-TH')
    fullTitle = obj.borrowerName + ' วันที่ยืม ' + date + ' เลขที่อ้างอิง ' + obj.documentNumber

    return fullTitle
  }

  const getDefaultActureReturnDate = () => {
    const today = moment().startOf('day')
    const periodDateEnd = periodInfo?.periodDateEnd
      ? moment(periodInfo.periodDateEnd, DATE_FORMAT)
      : null

    return periodDateEnd?.isValid() && today.isAfter(periodDateEnd, 'day')
      ? periodDateEnd.toDate()
      : today.toDate()
  }

  return (
    <>
      <Panel
        bordered
        style={{
          marginTop: 25,
          border: '1px solid #4e4b488c',
        }}
        header={
          periodInfo && (
            <div style={{ textAlign: 'left' }}>
              <Col lg={12} md={12} sm={24} xs={24}>
                <span>{periodInfo?.periodNo + ' (' + periodInfo?.startAndEndDate + ')'}</span>
              </Col>
              <Col lg={12} md={12} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <span>
                  {'งวดที่ ' + periodInfo?.periodNumber + '/' + periodInfo?.periodOfLength}
                </span>
              </Col>
            </div>
          )
        }
      >
        <Row style={{ marginTop: 30 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.voucherNumber.validators, formSchema.voucherNumber.label)}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {formSchema.voucherNumber.value ? (
              <b>{formSchema.voucherNumber.value}</b>
            ) : (
              <>
                <ErrorMessage error={errors[formSchema.voucherNumber.name]} />
                <Input
                  name={formSchema.voucherNumber.name}
                  defaultValue={formSchema.voucherNumber.value}
                  inputRef={register(isValidators(formSchema.voucherNumber.validators))}
                  placeholder={
                    formSchema.voucherNumber.hint
                      ? formSchema.voucherNumber.hint.toUpperCase()
                      : formSchema.voucherNumber.label
                  }
                  disabled={formSchema.voucherNumber.disabled}
                />
              </>
            )}

            {/* <ErrorMessage error={errors[formSchema.voucherNumber.name]} />
            <Input
              name={formSchema.voucherNumber.name}
              defaultValue={formSchema.voucherNumber.value || 'B-YY-XXXXX'}
              inputRef={register(isValidators(formSchema.voucherNumber.validators))}
              placeholder={'ระบุ' + formSchema.voucherNumber.label}
              disabled={formSchema.voucherNumber.disabled}
            /> */}
          </Col>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.receiveMoneyEtc.validators,
                formSchema.receiveMoneyEtc.label
              )}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <span>: {receiveMoneyEtcVal}</span>
            {/* <ErrorMessage error={errors[formSchema.receiveMoneyEtc.name]} />
            <Controller
              name={formSchema.receiveMoneyEtc.name}
              control={control}
              defaultValue={receiveMoneyEtcVal}
              value={receiveMoneyEtcVal}
              rules={isValidators(formSchema.receiveMoneyEtc.validators)}
              render={(props) => {
                return (
                  <InputGroup>
                    <Input
                      disabled
                      value={receiveMoneyEtcVal}
                      placeholder={'ระบุ' + formSchema.receiveMoneyEtc.label}
                      onChange={(value, e) => {
                        props.onChange(value)
                      }}
                    />
                    <InputGroup.Button
                      style={{ color: '#fff', backgroundColor: '#2ba888' }}
                      onClick={() => {
                        handleCallReceivedFrom(null)
                        setSearchNameOrId('')
                      }}
                    >
                      <Icon icon="ellipsis-h" size="lg" />
                    </InputGroup.Button>
                  </InputGroup>
                )
              }}
            /> */}
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.accountChannel.validators, formSchema.accountChannel.label)}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.accountChannel.name]} />
            <Controller
              name={formSchema.accountChannel.name}
              control={control}
              defaultValue={formSchema.accountChannel.value || '2'}
              rule={register(isValidators(formSchema.accountChannel.validators))}
              render={(props) => {
                return (
                  <RadioGroup
                    inline
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                      setAccChannel(value)
                    }}
                  >
                    {formSchema.accountChannel.options.map((item) => (
                      <Radio
                        key={item.value}
                        value={item.value}
                        disabled={item.disabled || formSchema.accountChannel.disabled || isCancel}
                      >
                        {item.label}
                      </Radio>
                    ))}
                  </RadioGroup>
                )
              }}
            />
          </Col>

          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.amountBorrowed.validators, formSchema.amountBorrowed.label)}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <span>: {budgetFormat(borrowAmont)}</span>
            {/* <ErrorMessage error={errors[formSchema.amountBorrowed.name]} />
            <Input
              name={formSchema.amountBorrowed.name}
              //defaultValue={formSchema.amountBorrowed.value || 0}
              value={borrowAmont || 0}
              inputRef={register(isValidators(formSchema.amountBorrowed.validators))}
              placeholder={'ระบุ' + formSchema.amountBorrowed.label}
              disabled={formSchema.amountBorrowed.disabled}
            /> */}
          </Col>
        </Row>

        {accChannel == '2' && (
          <>
            <Row>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <ControlLabel>
                  {requiredFiled(formSchema.bankAccount.validators, formSchema.bankAccount.label)}
                </ControlLabel>
              </Col>
              <Col lg={20} md={20} sm={24} xs={24}>
                <ErrorMessage error={errors[formSchema.bankAccount.name]} />
                <Controller
                  name={formSchema.bankAccount.name}
                  control={control}
                  defaultValue={formSchema.bankAccount.value}
                  rules={!isCancel && isValidators(formSchema.bankAccount.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        virtualized={false}
                        style={{ width: '100%' }}
                        searchable={true}
                        data={formSchema.bankAccount.options}
                        value={props.value}
                        menuAutoWidth
                        placeholder={'เลือก' + formSchema.bankAccount.label}
                        disabled={formSchema.bankAccount.disabled || isCancel}
                        onChange={(value) => {
                          props.onChange(value)
                          ///setAccChannel(value)
                          setIsEnableEdit(value != confirmAccChannel)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            </Row>
          </>
        )}

        {accChannel == 3 && (
          <>
            <Row>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <ControlLabel>
                  {requiredFiled(
                    formSchema.checkDocNumber.validators,
                    `${formSchema.checkDocNumber.label}`
                  )}
                </ControlLabel>
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                <ErrorMessage error={errors[formSchema.checkDocNumber.name]} />
                <Controller
                  name={formSchema.checkDocNumber.name}
                  control={control}
                  defaultValue={formSchema.checkDocNumber.value || ''}
                  rules={isValidators(formSchema.checkDocNumber.validators)}
                  render={(props) => {
                    return (
                      <Input
                        placeholder={'ระบุ' + formSchema.checkDocNumber.label}
                        value={props.value}
                        type="number"
                        maxLength={getMaxLengthData(formSchema.checkDocNumber.validators).value}
                        onChange={(value, e) => {
                          props.onChange(value)
                        }}
                        disabled={formSchema.checkDocNumber.disabled}
                        style={{ minWidth: '40%' }}
                      />
                    )
                  }}
                />
              </Col>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <ControlLabel>
                  {requiredFiled(
                    formSchema.checkDocDate.validators,
                    `${formSchema.checkDocDate.label}`
                  )}
                </ControlLabel>
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                <ErrorMessage error={errors[formSchema.checkDocDate.name]} />
                <Controller
                  key={formSchema.checkDocDate.name}
                  name={formSchema.checkDocDate.name}
                  control={control}
                  defaultValue={
                    formSchema.checkDocDate.value
                      ? moment(
                          moment(formSchema.checkDocDate.value).format(DATE_PICKER_FORMAT),
                          DATE_PICKER_FORMAT
                        ).toDate()
                      : new Date() > moment(periodInfo?.periodDateEnd, DATE_FORMAT).toDate()
                        ? moment(periodInfo?.periodDateEnd, DATE_FORMAT).toDate()
                        : new Date()
                  }
                  rules={isValidators(formSchema.checkDocDate.validators)}
                  render={(props) => {
                    return (
                      <DatePickerCustom
                        {...props}
                        startDate={periodInfo?.periodDateStart}
                        endDate={periodInfo?.periodDateEnd}
                      />
                    )
                  }}
                />
              </Col>
            </Row>
            <Row style={{ marginTop: 10 }}>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <ControlLabel>
                  {requiredFiled(
                    formSchema.checkBankInput.validators,
                    formSchema.checkBankInput.label
                  )}
                </ControlLabel>
              </Col>
              <Col lg={20} md={20} sm={24} xs={24}>
                <ErrorMessage error={errors[formSchema.checkBankInput.name]} />
                <Controller
                  name={formSchema.checkBankInput.name}
                  control={control}
                  defaultValue={formSchema.checkBankInput.value}
                  rules={isValidators(formSchema.checkBankInput.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        // style={{ minWidth: '40%' }}
                        style={{ width: '100%' }}
                        virtualized={false}
                        searchable={true}
                        data={formSchema.checkBankInput.options}
                        value={props.value}
                        menuAutoWidth
                        placeholder={`เลือก ${formSchema.checkBankInput.label}`}
                        disabled={formSchema.checkBankInput.disabled}
                        onChange={(value) => {
                          props.onChange(value)
                          // setAccChannel(value)
                          // setIsEnableEdit(value != confirmAccChannel)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            </Row>
          </>
        )}

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.listBorrowAdvance.validators,
                formSchema.listBorrowAdvance.label
              )}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {formSchema?.listBorrowAdvance?.disabled && formSchema?.listBorrowAdvance?.value ? (
              <span>{renderBorrowAdvance(formSchema?.listBorrowAdvance?.value)}</span>
            ) : (
              <>
                <ErrorMessage error={errors[formSchema.listBorrowAdvance.name]} />
                <Controller
                  name={formSchema.listBorrowAdvance.name}
                  control={control}
                  defaultValue={formSchema.listBorrowAdvance.value}
                  rules={isValidators(formSchema.listBorrowAdvance.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        virtualized={false}
                        searchable={true}
                        data={formSchema.listBorrowAdvance.options}
                        value={props.value}
                        block
                        placeholder="เลือก"
                        disabled={formSchema.listBorrowAdvance.disabled}
                        onClean={() => {
                          console.log('is clean')
                          //setIsCancel(false)
                        }}
                        onChange={(value) => {
                          let item = formSchema.listBorrowAdvance.options.find(
                            (i) => i.value == value
                          )
                          if (item?.waitCheckClearingInd == '1') {
                            setIsShowAlertMessage(true)
                            return
                          }

                          props.onChange(value)

                          let obj = accountingBorrowAvancesList.find((i) => i.id == value)
                          console.log('obj', obj)
                          setBorrowAmont(obj?.borrowAmount || 0)
                          setReceiveMoneyEtcVal(obj?.borrowerName)
                          setReceiveMoneyEtcId(obj?.id || value)
                          setPayActive(obj?.activityCode || '')
                          setIsCancel(false)
                          setDisabledForm(false)
                          setValue(formSchema?.cancelCheckBox?.name, false)
                          setValue(formSchema.payActive.name, obj?.activityCode || null)
                          setBorrowDate(obj?.borrowerDate)
                        }}
                      />
                    )
                  }}
                />
              </>
            )}
          </Col>

          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {/* <ControlLabel>
              {requiredFiled(formSchema.payActive.validators, formSchema.payActive.label)}
            </ControlLabel> */}
            <p>{`${formSchema.payActive.label} : `}</p>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {/* {console.log('formSchema.payActive.options ', formSchema.payActive.options)} */}
            <p>{getValueFromOptions(formSchema.payActive.options, payActive)}</p>
            {/* <ErrorMessage error={errors[formSchema.payActive.name]} /> */}
            <Controller
              name={formSchema.payActive.name}
              control={control}
              defaultValue={formSchema.payActive.value}
              // rules={!isCancel && isValidators(formSchema.payActive.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    virtualized={false}
                    searchable={false}
                    data={formSchema.payActive.options}
                    value={props.value}
                    block
                    placeholder="เลือก"
                    disabled={formSchema.payActive.disabled || isCancel}
                    style={{ display: 'none' }}
                    onChange={(value) => {
                      props.onChange(value)
                      setPayActive(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>

        {formSchema.actureReturnDate && !isCancel && (
          <Row style={{ marginTop: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <ControlLabel>
                {requiredFiled(
                  formSchema.actureReturnDate.validators,
                  formSchema.actureReturnDate.label
                )}
              </ControlLabel>
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              <ErrorMessage error={errors[formSchema.actureReturnDate.name]} />
              <Controller
                key={formSchema.actureReturnDate.name}
                name={formSchema.actureReturnDate.name}
                control={control}
                defaultValue={
                  formSchema.actureReturnDate.value
                    ? moment(formSchema.actureReturnDate.value, DD_MM_YYYY_SLASH).toDate()
                    : getDefaultActureReturnDate()
                }
                rules={!isCancel && isValidators(formSchema.actureReturnDate.validators)}
                render={(props) => {
                  return (
                    <DatePickerCustom
                      {...props}
                      disabled={formSchema.actureReturnDate.disabled || isCancel}
                      startDate={periodInfo?.periodDateStart}
                      endDate={periodInfo?.periodDateEnd}
                    />
                  )
                }}
              />
            </Col>
          </Row>
        )}

        {formSchema.cancelCheckBox && receiveMoneyEtcId && !borrowId && (
          <Row style={{ marginTop: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24} />
            <Col lg={20} md={20} sm={24} xs={24} style={{ width: 'auto' }}>
              <ErrorMessage error={errors[formSchema.cancelCheckBox.name]} />
              <Controller
                key={formSchema?.cancelCheckBox?.name}
                name={formSchema?.cancelCheckBox?.name}
                control={control}
                defaultValue={formSchema?.cancelCheckBox.value || false}
                value={isCancel}
                render={(props) => {
                  return (
                    <Checkbox
                      onChange={(value, checked) => {
                        props.onChange(checked)
                        setIsCancel(checked)
                        setDisabledForm(checked)
                      }}
                      checked={props.value}
                    >
                      <p style={{ marginTop: -6 }}>{formSchema?.cancelCheckBox?.label}</p>
                    </Checkbox>
                  )
                }}
              />
            </Col>
          </Row>
        )}

        {formSchema.reason && isCancel && receiveMoneyEtcId && (
          <Row style={{ marginTop: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <ControlLabel>
                {requiredFiled(formSchema.reason.validators, formSchema.reason.label)}
              </ControlLabel>
            </Col>
            <Col lg={20} md={20} sm={24} xs={24}>
              <ErrorMessage error={errors[formSchema.reason.name]} />
              <Controller
                name={formSchema.reason.name}
                control={control}
                defaultValue={formSchema.reason.value || ''}
                rules={isValidators(formSchema.reason.validators)}
                render={(props) => {
                  return (
                    <>
                      <Input
                        componentClass="textarea"
                        rows={4}
                        placeholder={'ระบุ' + formSchema.reason.label}
                        value={props.value}
                        maxLength={getMaxLengthData(formSchema.reason.validators).value}
                        onChange={(value, e) => {
                          props.onChange(value)
                        }}
                        disabled={formSchema.reason.disabled}
                      />
                      <ShowLimitLength
                        textLength={props.value?.length || 0}
                        maxLength={getMaxLengthData(formSchema.reason.validators)?.value}
                      />
                    </>
                  )
                }}
              />
            </Col>
          </Row>
        )}

        {formSchema.cancelType && isCancel && receiveMoneyEtcId && (
          <>
            <Row style={{ marginTop: 10 }}>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <ControlLabel>
                  {requiredFiled(formSchema.cancelType.validators, formSchema.cancelType.label)}
                </ControlLabel>
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                <ErrorMessage error={errors[formSchema.cancelType.name]} />
                <Controller
                  name={formSchema.cancelType.name}
                  control={control}
                  defaultValue={formSchema.cancelType.value || 1}
                  rule={register(isValidators(formSchema.cancelType.validators))}
                  render={(props) => {
                    console.log('formSchema.cancelType', formSchema.cancelType)
                    return (
                      <RadioGroup
                        inline
                        value={props.value}
                        onChange={(value) => {
                          props.onChange(value)
                          setCancelTypeCode(value)
                        }}
                      >
                        {formSchema.cancelType.options.map((item) => (
                          <Radio
                            key={item.value}
                            value={item.value}
                            disabled={formSchema.cancelType.disabled}
                          >
                            {item.label}
                          </Radio>
                        ))}
                      </RadioGroup>
                    )
                  }}
                />
              </Col>
            </Row>
            {formSchema.cancelTranferDate && cancelTypeCode == 1 && (
              <Row style={{ marginTop: 10 }}>
                <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <ControlLabel>
                    {requiredFiled(
                      formSchema.cancelTranferDate.validators,
                      formSchema.cancelTranferDate.label
                    )}
                  </ControlLabel>
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                  <ErrorMessage error={errors[formSchema.cancelTranferDate.name]} />
                  <Controller
                    key={formSchema.cancelTranferDate.name}
                    name={formSchema.cancelTranferDate.name}
                    control={control}
                    defaultValue={
                      formSchema.cancelTranferDate.value
                        ? moment(formSchema.cancelTranferDate.value, DD_MM_YYYY_SLASH).toDate()
                        : new Date() > moment(projectEndDate, DATE_FORMAT).toDate()
                          ? moment(projectEndDate, DATE_FORMAT).toDate()
                          : new Date()
                    }
                    rules={!isCancel && isValidators(formSchema.cancelTranferDate.validators)}
                    render={(props) => {
                      return (
                        <DatePickerCustom
                          {...props}
                          disabled={formSchema.cancelTranferDate.disabled}
                          startDate={borrowDate ? borrowDate : periodInfo?.periodDateStart}
                          endDate={
                            moment(projectEndDate).isAfter(new Date()) ? new Date() : projectEndDate
                          }
                        />
                      )
                    }}
                  />
                </Col>
              </Row>
            )}
            <Row style={{ marginTop: 10 }}>
                <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <ControlLabel>
                    {requiredFiled(
                      formSchema.cancelDate.validators,
                      formSchema.cancelDate.label
                    )}
                  </ControlLabel>
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                  <ErrorMessage error={errors[formSchema.cancelDate.name]} />
                  <Controller
                    key={formSchema.cancelDate.name}
                    name={formSchema.cancelDate.name}
                    control={control}
                    defaultValue={
                      formSchema.cancelDate.value
                        ? moment(formSchema.cancelDate.value, DD_MM_YYYY_SLASH).toDate()
                        : new Date() > moment(projectEndDate, DATE_FORMAT).toDate()
                          ? moment(projectEndDate, DATE_FORMAT).toDate()
                          : new Date()
                    }
                    rules={!isCancel && isValidators(formSchema.cancelDate.validators)}
                    render={(props) => {
                      return (
                        <DatePickerCustom
                          {...props}
                          disabled={formSchema.cancelDate.disabled}
                          startDate={borrowDate ? borrowDate : periodInfo?.periodDateStart}
                          endDate={
                            moment(projectEndDate).isAfter(new Date()) ? new Date() : projectEndDate
                          }
                        />
                      )
                    }}
                  />
                </Col>
              </Row>
          </>
        )}

        <Row style={{ marginTop: 30 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.attachFiles.validators,
                formSchema.attachFiles.label || 'เอกสารแนบประกอบ'
              )}
            </ControlLabel>
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.attachFiles.name]} />
            <Controller
              key={formSchema.attachFiles.name}
              name={formSchema.attachFiles.name}
              control={control}
              rules={isValidators(fileTableData.length == 0 && formSchema.attachFiles.validators)}
              defaultValue={''}
              render={(props) => {
                return (
                  <Uploader
                    accept={formSchema.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'}
                    autoUpload={false}
                    disabled={formSchema.attachFiles.disabled}
                    fileListVisible={true}
                    listType="picture-text"
                    fileList={props.value || []}
                    onChange={(fileList) => {
                      if (isEmpty(fileList)) {
                        props.onChange(undefined)
                      } else {
                        let file = fileList[fileList.length - 1]

                        if (
                          file.blobFile.size >
                          (formSchema?.attachFiles?.fileSize || defaultMaxFileSize) * 1024 * 1024
                        ) {
                          notification.open('error', {
                            title: `ขนาดไฟล์เกิน ${
                              formSchema.attachFiles.fileSize || defaultMaxFileSize
                            } MB`,
                            duration: 5000,
                          })
                          return
                        }

                        if (isImageOrPdf(file.blobFile.type)) {
                          props.onChange(fileList)
                          setFileTypeError(false)
                        } else {
                          setFileTypeError(true)
                          notification.open('error', {
                            title:
                              'ชนิดที่รองรับ ' + formSchema.attachFiles.fileType ||
                              '.jpg, .jpeg, .png, .pdf',
                            duration: 5000,
                          })
                        }
                      }
                    }}
                    draggable
                  >
                    <div>
                      <Icon size="2x" icon="upload2" />
                      <small className="uploder__text"></small>
                      {`  อัปโหลดไฟล์ ชนิดที่รองรับ : ${
                        formSchema.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'
                      } , ขนาดไฟล์ไม่เกิน ${
                        formSchema.attachFiles.fileSize || defaultMaxFileSize
                      } MB`}
                    </div>
                    {/* <div style={{ lineHeight: '100px' }}>
                      <Icon size="4x" icon="upload2" />
                      <small
                        style={{
                          marginTop: '-70px',
                          display: 'block',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                      </small>
                    </div> */}
                  </Uploader>
                )
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 25 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}></Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            {fileTableData.length > 0 && (
              <IncomeRecordFileTable
                data={fileTableData}
                deleteable={true}
                onPreview={onPreview}
                onDownload={onDownload}
                onDelete={(rowData) => handleDeleteFileTable(rowData)}
              />
            )}
          </Col>
        </Row>
      </Panel>

      <div className="modal-container">
        <Modal
          full
          show={showReceiveMoneyEtc}
          size="lg"
          onHide={() => setShowReceiveMoneyEtc(false)}
        >
          <Modal.Header>
            <Modal.Title>เลือการรับทุนจากแหล่งอื่น</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <>
              <Row>
                <Col lg={12} md={12} sm={24} xs={24} style={{ width: '60%' }}>
                  <InputGroup style={{ width: '100%' }}>
                    <Input
                      defaultValue={searchNameOrId}
                      value={searchNameOrId}
                      placeholder={'ระบุชื่อ หรือ เลขที่ผู้เสียภาษี'}
                      onChange={(value) => setSearchNameOrId(value)}
                    />

                    <InputGroup.Button
                      style={{ color: '#fff', backgroundColor: '#2ba888' }}
                      onClick={() => handleCallReceivedFrom(searchNameOrId)}
                    >
                      <Icon icon="search" size="lg" /> ค้นหา
                    </InputGroup.Button>
                  </InputGroup>
                </Col>
                <Col lg={12} md={12} sm={24} xs={24} style={{ width: '40%' }}>
                  <CancelButton
                    onClick={() => {
                      handleCallReceivedFrom(null)
                      setSearchNameOrId('')
                    }}
                  >
                    ยกเลิก
                  </CancelButton>
                </Col>
              </Row>

              {receivedFromSchema?.values?.length > 0 ? (
                <div>
                  <Table
                    //autoHeight
                    height={400}
                    data={receivedFromSchema?.values || []}
                    wordWrap
                    style={{ marginTop: 10 }}
                  >
                    <Column width={150}>
                      <HeaderCell>เลขที่ผู้เสียภาษี</HeaderCell>
                      {/* <Cell dataKey="taxId" /> */}
                      <Cell>
                        {(rowData) => {
                          return <>{maskIdCard(rowData.taxId)}</>
                        }}
                      </Cell>
                    </Column>

                    <Column minWidth={200} flexGrow={1}>
                      <HeaderCell>ชื่อ</HeaderCell>
                      <Cell dataKey="name" />
                    </Column>

                    <Column minWidth={200} flexGrow={1}>
                      <HeaderCell>ที่อยู่</HeaderCell>
                      <Cell dataKey="address" />
                    </Column>

                    <Column width={80} fixed="right">
                      <HeaderCell>เลือก</HeaderCell>
                      <Cell>
                        {(rowData) => {
                          return (
                            <>
                              <Button
                                appearance="primary"
                                size="xs"
                                onClick={() => {
                                  handleSelectVender(rowData)
                                }}
                              >
                                เลือก
                              </Button>
                            </>
                          )
                        }}
                      </Cell>
                    </Column>
                  </Table>
                </div>
              ) : (
                <>
                  <div style={{ padding: 5 }}>
                    <List bordered>
                      <List.Item>- ไม่พบข้อมูล -</List.Item>
                    </List>
                  </div>
                </>
              )}
            </>
          </Modal.Body>
          <Modal.Footer>
            {/* <Button onClick={handleClickReciveMoneyEtc} appearance="primary">
                บันทึก
              </Button> */}
            <Button onClick={() => setShowReceiveMoneyEtc(false)} appearance="subtle">
              ยกเลิก
            </Button>
          </Modal.Footer>
        </Modal>
      </div>

      <ConfirmWidget
        title={`แจ้งเตือน`}
        size="sm"
        show={isShowAlertMessage}
        detail={`ไม่สามารถคืนเงินทดรองจ่ายได้ กรุณาทำการเคลียริ่งเช็คก่อน`}
        onCancle={() => setIsShowAlertMessage(false)}
        hideCancle
        onConfirm={() => setIsShowAlertMessage(false)}
        confirmBtn={`ตกลง`}
      />
    </>
  )
}
